import { FC } from "react";
import { useHistory } from "react-router";
import { ReactComponent as BackIcon } from "./../../assets/icons/back.svg";
import { StyledGoBackBtn } from "./style";

interface IGoBackBtn {
  backPath?: string;
  className?: string;
}

export const GoBackBtn: FC<IGoBackBtn> = ({ backPath, className }) => {
  let { goBack, push } = useHistory();

  return (
    <StyledGoBackBtn
      onClick={() => (backPath ? push(backPath) : goBack())}
      className={`btn btn__outline btn__gen flex Back ${className ?? ""}`}
    >
      <span>
        <BackIcon />
      </span>
      Back
    </StyledGoBackBtn>
  );
};
